import { combineReducers } from '@reduxjs/toolkit';

import comboSummary from './comboSummary';
import common from '../common';
import destinationContent from './destinationContent';
import error from './error';
import labels from './labels';
import message from './message';
import searchInformation from './searchInformation';

// `common` is seeded through `preloadedState`.
const comboSummaryApp = combineReducers({
  comboSummary,
  common,
  destinationContent,
  error,
  labels,
  message,
  searchInformation,
});

export default comboSummaryApp;
